import React from 'react';
import LoginForm from '../Components/LoginForm/LoginForm';
function Login() {
  return (
    <div className='d-flex justify-content-center  h-100'>

<LoginForm/>
    </div>
  )
}

export default Login